import { SimpleTransferOrderReceivingCreatePage } from "@/features/simple-transfer-order-receiving/pages/SimpleTransferOrderReceivingCreatePage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/receiving/simple-transfer-order/create")({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["simple_to_receiving.create"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: SimpleTransferOrderReceivingCreatePage,
});
